import React, { useMemo } from "react";
import useAxios from "axios-hooks";
import FluentSelect from "../Forms/FluentSelect";

const UnitDropdown = ({ cobrandId, isMulti = true, ...rest }) => {
    const [{ data: units, loading: loadingUnits }] = useAxios("/internal/cobrand/all-client-schools");

    const unitOptions = useMemo(() => {
        if (!units || !cobrandId) return [];
        return units
            .filter((u) => u.coBrandId === cobrandId)
            .map((u) => ({
                value: u.clientSchoolId,
                label: u.schoolName,
            }));
    }, [units, cobrandId]);

    return (
        <FluentSelect
            options={unitOptions}
            disabled={loadingUnits}
            isMulti={isMulti}
            {...rest}
        />
    );
};

export default UnitDropdown;
